import React, { ComponentType, Suspense, lazy } from 'react';
import { Modal, TModal } from './Modal';

export interface ICalendarModal extends TModal {
  handleClickDay: (date: Date) => void;
  onCancel: () => void;
  calValue?: Date;
  locale: string;
}

export const CalendarModal = React.forwardRef<HTMLDivElement, ICalendarModal>(
  ({ handleClickDay, onCancel, calValue, locale, size, ...props }, ref) => {
    const Calendar = lazy(
      () =>
        import('react-calendar') as unknown as Promise<{
          default: ComponentType<any>;
        }>,
    );
    return (
      <Modal
        noHeader
        size={size ?? 'cal'}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        ref={ref}
        {...props}
        initialFocusGetter={(modalRef) => {
          return modalRef?.querySelector(
            '.react-calendar__tile--active',
          ) as HTMLElement;
        }}
      >
        <Suspense fallback={null}>
          <Calendar
            onClickDay={handleClickDay}
            locale={locale}
            value={calValue ?? new Date()}
            nextLabel="›"
            next2Label="»"
            prevLabel="‹"
            prev2Label="«"
          />
        </Suspense>
      </Modal>
    );
  },
);

CalendarModal.displayName = 'CalendarModal';
